import type {ReactElement} from 'react';
import type {SliderBodyProps} from '../../slider-control.types';
import {SLIDER_HIDE_INPUT_PROPS} from '../../slider-control.types';
import {StepButton} from '../step-button/step-button';
import {SliderTextInput} from '../slider-text-input/slider-text-input';
import styles from '../../slider-control.module.scss';

/**
 * Renders only the `inputOptions` block (step buttons + text input). The range input must sit
 * outside `labelRow`, so each parent renders SliderBody inside labelRow and the range input itself.
 */
export function SliderBody({
  descriptor,
  numericValue,
  displayValue,
  effectiveMax,
  isInputActive,
  renderExtraButton,
  inputOptionsClassName,
  onActivate,
  onDeactivate,
  onStep,
  onTextChange,
}: SliderBodyProps): ReactElement {
  const step = descriptor.step ?? 1;
  const min = descriptor.min;
  const max = effectiveMax;
  const unit = descriptor.unit;
  const hideStepButtons = SLIDER_HIDE_INPUT_PROPS.has(descriptor.property);

  return (
    <div className={`${styles.inputOptions} ${inputOptionsClassName ?? ''}`}>
      <div className={`${styles.stepControlsContainer} ${!hideStepButtons ? styles.stepEnabled : ''} ${isInputActive ? styles.stepControlsActive : ''}`}>
        {hideStepButtons ? null : (
          <StepButton
            direction="minus"
            disabled={numericValue <= min}
            onClick={(): void => {
              onStep(-1);
            }}
          />
        )}
        <SliderTextInput
          centerAlign={!unit}
          isActive={isInputActive}
          max={max}
          min={min}
          onActivate={onActivate}
          onDeactivate={onDeactivate}
          onChange={onTextChange}
          propertyName={descriptor.property}
          step={step}
          unit={unit}
          value={displayValue}
        />
        {hideStepButtons ? null : (
          <StepButton
            direction="plus"
            disabled={numericValue >= max}
            onClick={(): void => {
              onStep(1);
            }}
          />
        )}
      </div>
      {renderExtraButton ? renderExtraButton() : null}
    </div>
  );
}
